var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"mb-6 text-theme-main"},[_vm._v("Hello. I am a VUE Component, called via Vue Router link, this time from the Sidebar Menu.")])
}
var staticRenderFns = []

export { render, staticRenderFns }